
import { required } from 'vuelidate/lib/validators'
import vehicleSelectionTargetMixin from '@/mixins/vehicleSelectionTargetMixin'

export default {
  name: 'LedSearchFromVehicles',

  mixins: [vehicleSelectionTargetMixin],

  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default() {
        return { vehicles: [] }
      },
    },
    oneChoice: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default() {
        return []
      },
    },
    showButton: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      form: {
        type: 1,
        brand: null,
        model: null,
        year: null,
      },
      vehicles_type: [],
      brands_list: [],
      models_list: [],
      years_list: [],
      selected_vehicles: [],
    }
  },

  validations: {
    form: {
      model: {
        required,
      },
      brand: {
        required,
      },
    },
  },

  watch: {
    'form.type': function (val) {
      this.loadBrandsForType(val)
      this.form.brand = null
      this.form.model = null
      this.form.year = null
    },

    'form.brand': async function (val) {
      if (val) {
        try {
          const { data } = await this.$vehicleService.fetchVehicleSearchVehicles(
            this.form.type,
            this.form.brand.id
          )
          this.models_list = data
          this.form.model = null
        } catch (error) {
          console.error('Error loading models:', error)
          this.models_list = []
          this.form.model = null
        }
      } else {
        this.form.model = null
        this.models_list = []
      }
    },
    'form.model': function () {
      if (!this.showButton) {
        this.onSubmit()
      }
    },
  },

  mounted() {
    this.$vehicleTypeService
      .fetchVehicleSearchTypes()
      .then(({ data }) => {
        data.forEach(el => {
          this.vehicles_type.push({
            html: el.name,
            value: el.id,
          })
        })
      })
      .catch(() => {})
    this.loadBrandsForType(this.form.type)
    if (this.order && this.order.vehicles) {
      this.selected_vehicles = JSON.parse(JSON.stringify(this.order.vehicles))
    }
  },

  methods: {
    loadBrandsForType(vehicleTypeId) {
      return this.$brandService
        .fetchVehicleSearchBrands(vehicleTypeId)
        .then(({ data }) => {
          this.brands_list = data || []
        })
        .catch(() => {
          this.brands_list = []
        })
    },

    filterVehicleWithAliases(options, search) {
      if (!search) return options

      const searchLower = search.toLowerCase()

      return options.filter(option => {
        // Recherche dans le nom du véhicule
        if (option.name && option.name.toLowerCase().includes(searchLower)) {
          return true
        }

        // Recherche dans les alias
        if (option.vehicle_aliases && option.vehicle_aliases.length > 0) {
          return option.vehicle_aliases.some(
            alias =>
              alias.name && alias.name.toLowerCase().includes(searchLower)
          )
        }

        return false
      })
    },

    dropdownShouldOpen() {
      return true
    },

    onSubmit() {
      this.$v.$touch()
      if (this.inline) {
        if (
          this.form.model &&
          !this.selected_vehicles.find(
            vehicle => vehicle.id === this.form.model.id
          )
        ) {
          const modelToAdd = {
            ...this.form.model,
            brand: this.form.brand
              ? { ...this.form.brand }
              : {
                  name: this.$t(
                    'components.ledSearchFormVehicles.unknownBrand'
                  ),
                },
          }
          this.selected_vehicles.push(modelToAdd)
          this.selected_vehicles = [...this.selected_vehicles]
        }
        const vehicleIds = this.selected_vehicles.map(vehicle => vehicle.id)
        if (this.order?.id) {
          this.$orderService
            .associateVehicles(this.order.id, {
              vehicles: vehicleIds,
            })
            .then(() => {
              this.form.model = null
              this.form.brand = null
              this.$v.$reset()
            })
        }
        if (this.oneChoice && this.selected_vehicles.length > 0) {
          // Émettre le véhicule complet pour l'historique
          this.$emit('vehicleSelected', this.selected_vehicles[0])
          this.form.model = null
          this.form.brand = null
          this.$emit('input', this.selected_vehicles[0].id)
          this.$v.$reset()
        }
      } else if (!this.$v.$anyError) {
        const consumed = this.consumeVehicleSelectionTarget(this.form.model)

        // Émettre le véhicule sélectionné pour l'historique
        this.$emit('vehicleSelected', this.form.model)

        if (!consumed) {
          this.$router.push(
            this.localePath({
              name: 'recherche-led-accessoires-brand-type-typeid',
              params: {
                brand: this.$slugify(this.form.brand.name).toLowerCase(),
                type: this.$slugify(this.form.model.name).toLowerCase(),
                typeid: this.form.model.id,
              },
            })
          )
        }
        this.$emit('closeModal')
      }
    },

    removeVehicle(vehicleIdToRemove) {
      this.selected_vehicles = this.selected_vehicles.filter(
        vehicle => vehicle.id !== vehicleIdToRemove
      )

      const vehicleIds = this.selected_vehicles.map(vehicle => vehicle.id)
      if (this.order?.id)
        this.$orderService.associateVehicles(this.order.id, {
          vehicles: vehicleIds,
        })
      this.$emit('input', null)
    },
  },
}
